import CafeteriaOrders from './OrdersByClasses'


export { dataKey } from './dataKey'

export default CafeteriaOrders
